import { render, staticRenderFns } from "./DeleteShare.vue?vue&type=template&id=4dfc241e"
import script from "./DeleteShare.vue?vue&type=script&lang=js"
export * from "./DeleteShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports